import { memo } from "react";
import { prop, pipe, propEq, equals, pick } from "ramda";
import { initializeConfirm } from "@domain-ui";
import OrganizationRow from "./OrganizationRow";
import OrganizationsHeaders from "./OrganizationsHeaders";
import { Tr } from "./organizationslist.styles";
import { allGenderTypes } from "utils/genders";
import { getColorUsingOption } from "utils/colors";
import { measurementByPeriod } from "utils/measurement";
import { getPeriod } from "utils/periods";
import { sort } from "utils/sort";
import { format } from "utils/format";
import { measurementsParams } from "utils/measurementsWithMetadata";
import { useUnitListsContext } from "@unitLists";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function OrganizationsList(props) {
  var _activeUnitList$units;
  var query = props.query,
    setQuery = props.setQuery,
    measure = props.measure,
    lookupOrganization = props.lookupOrganization,
    measurementsWithMetadata = props.measurementsWithMetadata,
    drilldown = props.drilldown,
    removeOrganization = props.removeOrganization,
    extractValueFunc = props.extractValueFunc,
    sortFunc = props.sortFunc,
    disableUnitsInteraction = props.disableUnitsInteraction,
    relativeToColors = props.relativeToColors;
  var _useUnitListsContext = useUnitListsContext(),
    defaultUnitListsLoaded = _useUnitListsContext.defaultUnitListsLoaded,
    activeUnitList = _useUnitListsContext.activeUnitList;
  var sortedOrganizations = sortFunc(measurementsWithMetadata);
  var genderKeys = Object.keys(allGenderTypes);
  var rows = sortedOrganizations.map(function (id, idx) {
    var _getColorUsingOption;
    var organization = lookupOrganization(id);
    var getGender = function getGender(measureId) {
      var _measure$submeasures$;
      return measure === null || measure === void 0 ? void 0 : (_measure$submeasures$ = measure.submeasures.find(propEq("measureId", measureId))) === null || _measure$submeasures$ === void 0 ? void 0 : _measure$submeasures$.gender;
    };
    var paramsExists = query.periodType && query.dateTo;
    var orgMeasurements = (measurementsWithMetadata === null || measurementsWithMetadata === void 0 ? void 0 : measurementsWithMetadata.filter(propEq("organizationId", id))) || [];
    var genderSortedMeasurements = sort(function (x) {
      return genderKeys.indexOf(getGender(x.measureId));
    }, orgMeasurements);
    var values = paramsExists ? genderSortedMeasurements.map(pipe(prop("measurements"), measurementByPeriod(getPeriod(query.periodType, query.dateTo)), extractValueFunc)) : [];
    var relativeToValue = relativeToColors && values[0] && values[0] * (measure.soughtValue === "Lågt" ? -1 : 1);
    var organizationIndex = query.units.findIndex(function (x) {
      return x === id;
    });
    var color = (_getColorUsingOption = getColorUsingOption(query.colorSettings, activeUnitList, organizationIndex, id, relativeToColors && relativeToValue)) === null || _getColorUsingOption === void 0 ? void 0 : _getColorUsingOption.hex;

    // console.log("Debug", values, relativeToValue, measure, organization)

    return /*#__PURE__*/_jsx(Tr, {
      "aria-rowindex": idx + 2,
      children: /*#__PURE__*/_jsx(OrganizationRow, {
        organization: organization,
        values: values.map(format(measure === null || measure === void 0 ? void 0 : measure.measureUnit)),
        removeOrganization: removeOrganization,
        drilldown: drilldown,
        measure: measure,
        disableUnitsInteraction: disableUnitsInteraction,
        color: color
      })
    }, id);
  });
  return sortedOrganizations.length > 0 ? /*#__PURE__*/_jsxs("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    },
    "aria-rowcount": sortedOrganizations.length + 1,
    "aria-colcount": "3",
    children: [/*#__PURE__*/_jsx("caption", {
      className: "hidden-styles",
      children: "Rapporterade v\xE4rden f\xF6r dina valda enheter:"
    }), /*#__PURE__*/_jsxs("tbody", {
      children: [/*#__PURE__*/_jsx(OrganizationsHeaders, {
        query: query,
        setQuery: setQuery,
        measure: measure,
        measurementsWithMetadata: measurementsWithMetadata
      }), rows]
    })]
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: defaultUnitListsLoaded && !(activeUnitList !== null && activeUnitList !== void 0 && (_activeUnitList$units = activeUnitList.units) !== null && _activeUnitList$units !== void 0 && _activeUnitList$units.length) && initializeConfirm({
      callback: function callback() {},
      title: "Välj enhet eller enhetslista",
      ingress: "Välj en enhetslista eller minst en enhet via Sök efter enheter för att se data.",
      confirmLabel: "Stäng",
      hideCancel: true
    })
  });
}, function (prev, curr) {
  return prev.query.units.length < curr.query.units.length && equals(measurementsParams(prev.query), measurementsParams(curr.query)) && equals(prev.query.sort, curr.query.sort) && equals(pick(["activeUnitList", "measurementsWithMetadata", "disableUnitsInteraction"], prev), pick(["activeUnitList", "measurementsWithMetadata", "disableUnitsInteraction"], curr));
});